export default __webpack_public_path__ + "fonts/a7aee42a882150b288fdce296fe6b99d.svg";